module.exports = __webpack_public_path__ + "img/電気回路_6_2_5.83b8fcb5.png";